<template>
    <!-- main area -->
    <!-- <div class="d-flex align-center justify-center" style="min-height: 300px;">
      Search Page!
    </div> -->
  <v-row>
    <!-- on enter key perform search -->
    <v-col class="pb-0 pr-0" cols="11" v-if="!simpleSearch">
      <v-container class="pb-0 pr-0">
        <v-card class="d-inline-flex w-100" color="#c4c4c4">
            
           <!-- categories if tab is indicator -->
            <v-select
              v-if="table == 'Indicators'"
              v-model="category"
              :items="lut_Indicator_categories"
              label="Category"
              class="w-25 ml-2 mt-2"
            ></v-select>

            <!-- categories if tab is survey -->
            <v-select
              v-if="table == 'Surveys'"
              v-model="category"
              :items="lut_Survey_categories"
              label="Category"
              class="w-25 ml-2 mt-2"
            ></v-select>

            <!-- categories if tab is summary -->
            <v-select
              v-if="table == 'Summary'"
              v-model="category"
              :items="lut_Summary_categories"
              label="Category"
              class="w-25 ml-2 mt-2"
            ></v-select>

            <v-combobox
              v-model="input"
              :items="search_items"
              prepend-inner-icon="mdi-magnify"
              class="w-75 ml-2 mr-2 mt-2"
            ></v-combobox>

            <v-btn class="ml-3 mt-5" max_height size="large" theme="dark" @click="addChip" @keyup.enter="addChip">
                <v-icon icon="mdi-plus" size="large"></v-icon>
            </v-btn>

            <v-btn class="ml-2 mt-5 mr-2" max_height size="large" theme="dark" @click="submitSearch" @keyup.enter="submitSearch">
                  <v-icon icon="mdi-magnify" size="large"></v-icon>
            </v-btn> 

            <v-btn rounded="circle" elevation="0" class="mt-1 ml-1" size="x-small" color="#c4c4c4">
              <v-icon icon="mdi-information" size="x-large"></v-icon>
              <v-tooltip activator="parent">
                The ‘General Search’  functionality allows for the searching of any word <br>
                across key columns for both the survey and indicator databases. <br>
                <br>
                In the lower right, the drop down arrow can be clicked to transition into the ’ Advanced Search’  <br>
                functionality. This option  allows for searches based on values in the databases look up tables. <br>
                <br>
                With the 'Advanced Search' a category is chosen from the drop-down list on the left-hand side of the search bar. <br>
                The values present in the selected categories lookup table will then populate the drop-down list in the middle.<br>
                To add the selected value as a search parameter the ‘ + ‘ button can be pressed. Once all desired search parameters <br>
                have been added a query can be performed with the search button. Depending on which tab is selected <br>
                (Survey/Indicator/Summary) the available search categories will be different. When the Summary tab is selected only <br>
                categories that are present in both the Surveys and Indicators will be displayed. <br>
                <br>
                Individual search results can be clicked to display further information about the survey or indicator. <br>
                To navigate back to the search results tables click either the ‘Survey’ or ‘Indicator’ tabs, <br>
                and the results will reload. <br>
                <br>
                Additionally, the ‘Summary’ tab can be clicked in order to see a summary of the <br>
                search results across both indicators and surveys. <br>
                <br>
                When using the ‘Advanced Search’ a category may be selected that is not <br>
                compatible across both surveys and indicators. If this is the case the incompatible table, <br>
                and the summary tab will be disabled. <br>
                <br>
                To the right of the 'Summary Tab' there is a download button. Clicking here will download<br>
                a csv file of the currently loaded table. This option is disabled if the summary tab is currently selected. <br>
                <br>
              </v-tooltip>
            </v-btn>

          </v-card>
      </v-container>

      <v-container class="pt-0 pb-0 pr-0">
        <v-card color="#ebebeb" height="75px" class="d-flex align-center justify-center" v-if="!search_chips.length">
            <v-text>Use the + button to add search parameters</v-text>
        </v-card>
        <v-card color="#ebebeb" height="75px" v-if="search_chips.length">
          <!-- dont allow duplicate chips -->
          <v-chip-group class="mt-3 ml-3 m-b3" style="display: inline" v-for="chip in this.search_chips" :key='chip'>
            
            <v-chip 
                closable
                @click:close="removeChip(chip)">
                {{ chip }}
            </v-chip>
          </v-chip-group>
        </v-card>
      </v-container>


      <v-container class="text-right pt-0 pb-0 pr-0">
        <v-card color="#ebebeb" height="20px">
          <v-btn class="md-2" size="x-small" color="#ebebeb" elevation="0" @click="switchSearch">
            <v-icon icon="mdi-chevron-up" size="x-large">
            </v-icon>
          </v-btn>
        </v-card>
      </v-container>

    </v-col>

    <v-col class="pb-0 pr-0" cols="11" v-if="simpleSearch">
      <v-container class="pb-0 pr-0">
        <v-card class="d-inline-flex w-100" color="#c4c4c4">
            <v-text-field
              v-model="input"
              :items="search_items"
              prepend-inner-icon="mdi-magnify"
              class="w-75 ml-2 mr-2 mt-2"
              @keyup.enter="submitSearch"
            ></v-text-field>

            <v-btn class="ml-2 mt-5 mr-2" max_height size="large" theme="dark" @click="submitSearch">
                  <v-icon icon="mdi-magnify" size="large"></v-icon>
            </v-btn> 

            <v-btn rounded="circle" elevation="0" class="mt-1 ml-1" size="x-small" color="#c4c4c4">
              <v-icon icon="mdi-information" size="x-large"></v-icon>
              <v-tooltip activator="parent">
                The ‘General Search’  functionality allows for the searching of any word <br>
                across key columns for both the survey and indicator databases. <br>
                <br>
                In the lower right, the drop down arrow can be clicked to transition into the ’ Advanced Search’  <br>
                functionality. This option  allows for searches based on values in the databases look up tables. <br>
                <br>
                With the 'Advanced Search' a category is chosen from the drop-down list on the left-hand side of the search bar. <br>
                The values present in the selected categories lookup table will then populate the drop-down list in the middle.<br>
                To add the selected value as a search parameter the ‘ + ‘ button can be pressed. Once all desired search parameters <br>
                have been added a query can be performed with the search button. Depending on which tab is selected <br>
                (Survey/Indicator/Summary) the available search categories will be different. When the Summary tab is selected only <br>
                categories that are present in both the Surveys and Indicators will be displayed. <br>
                <br>
                Individual search results can be clicked to display further information about the survey or indicator. <br>
                To navigate back to the search results tables click either the ‘Survey’ or ‘Indicator’ tabs, <br>
                and the results will reload. <br>
                <br>
                Additionally, the ‘Summary’ tab can be clicked in order to see a summary of the <br>
                search results across both indicators and surveys. <br>
                <br>
                When using the ‘Advanced Search’ a category may be selected that is not <br>
                compatible across both surveys and indicators. If this is the case the incompatible table, <br>
                and the summary tab will be disabled. <br>
                <br>
                To the right of the 'Summary Tab' there is a download button. Clicking here will download<br>
                a csv file of the currently loaded table. This option is disabled if the summary tab is currently selected. <br>
                <br>
              </v-tooltip>
            </v-btn>

          </v-card>
      </v-container>

      <v-container class="text-right pt-0 pb-0 pr-0">
        <v-card color="#c4c4c4" height="20px">
          <v-btn class="md-2" size="x-small" color="#c4c4c4" elevation="0" @click="switchSearch">
            <v-icon icon="mdi-chevron-down" size="x-large">
            </v-icon>
          </v-btn>
        </v-card>
      </v-container>
      
    </v-col>
    
  </v-row>

  <v-row class="mt-4 ml-5">
    <v-container>

      <v-row class='mb-4 ml-4'>
        <v-tabs density="compact" v-model="table">
              <v-tab v-if="survey_enabled" value="Surveys" @click="submitSearch">Surveys</v-tab>
              <v-tab v-if="!survey_enabled" value="Surveys" disabled>Surveys</v-tab>

              <v-tab v-if="indicator_enabled" value="Indicators" @click="submitSearch">Indicators</v-tab>
              <v-tab v-if="!indicator_enabled" value="Indicators" disabled>Indicators</v-tab>

              <v-tab v-if="summary_enabled" value="Summary" @click="submitSearch">Summary</v-tab>
              <v-tab v-if="!summary_enabled" value="Summary" disabled>Summary</v-tab>
        </v-tabs>

        <v-btn elevation="0" v-if="table != 'Summary'">
          <download-csv :data="serverItems">
            <v-icon icon="mdi-download-box"></v-icon>    
          </download-csv>
        </v-btn>
        <v-btn elevation="0" v-if="table == 'Summary'" disabled>
          <download-csv :data="serverItems" >
            <v-icon icon="mdi-download-box"></v-icon>    
          </download-csv>
        </v-btn>
      </v-row>

      <v-card 
        v-if="is_summary && !is_metadata"
        title="Search Summary"
        dense
      >

        <v-card-text>Number of Surveys Found: {{ survey_num }}</v-card-text>

        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-title>
              Survey Species: {{ survey_species_num }}
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              {{ survey_species_list }}
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card-text>Number of Indicators: {{ indicator_num }}</v-card-text>
        
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-title>
              Indicator EBV Classes: {{ indicator_ebv_num }}
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              {{ indicator_ebv_list }}
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-list class='ml-5' v-for="species in this.indicator_species" :key='species'> 
          <v-list-item-subtitle>{{ species }}</v-list-item-subtitle>
        </v-list>

      </v-card>

      <v-card v-if="!is_summary && !is_metadata">
        <v-data-table
          class="mr-5 mt-5"
          v-model:items-per-page="itemsPerPage"
          :items-length="totalItems"
          :items="serverItems"
          :loading="loading"
          @update:options="loadItems"
          @click:row="loadAllMetadata">
        </v-data-table>
      </v-card>

      <v-card class="mt-5" v-if="is_metadata">
        <!-- for Indicators -->
        <v-card-title v-if="table == 'Indicators'"> {{indicatorMetadata.indicator}} </v-card-title>
        <v-card-subtitle v-if="table == 'Indicators'"> {{indicatorMetadata.indicator_category}} </v-card-subtitle>
        <v-card-text v-if="table == 'Indicators'"> Geographic Region: {{indicatorMetadata.geographic_region}} </v-card-text>
        <v-card-text v-if="table == 'Indicators'"> Objective: {{indicatorMetadata.objective}} </v-card-text>
        <v-card-text v-if="table == 'Indicators'"> Ecosystem: {{indicatorMetadata.ecosystem}} </v-card-text>
        <v-card-text v-if="table == 'Indicators'"> Focal Component: {{indicatorMetadata.focal_component}} </v-card-text>
        <v-card-text v-if="table == 'Indicators'"> Metric: {{indicatorMetadata.metric}} </v-card-text>
        <v-card-text v-if="table == 'Indicators'"> Notes: {{indicatorMetadata.notes}} </v-card-text>

        <!-- for Surveys -->
        <v-card-title v-if="table == 'Surveys'"> {{surveyMetadata.survey_name}} </v-card-title>
        <v-card-subtitle v-if="table == 'Surveys'"> {{surveyMetadata.survey_description}} </v-card-subtitle>
        <v-card-text v-if="table == 'Surveys'"> Survey Info Collected: {{surveyMetadata.survey_info_collected}} </v-card-text>
        <v-card-text v-if="table == 'Surveys'"> Sampling Details: {{surveyMetadata.sampling_details}} </v-card-text>
        <v-card-text v-if="table == 'Surveys'"> Collection Frequency: {{surveyMetadata.collection_frequency}} </v-card-text>
        <v-card-text v-if="table == 'Surveys'"> Physical Samples: {{surveyMetadata.is_physical_samples}}</v-card-text>
        <v-card-text v-if="table == 'Surveys'">Details: {{surveyMetadata.physical_samples_details}}</v-card-text>
        <v-card-text v-if="table == 'Surveys'"> Notes: {{surveyMetadata.notes}} </v-card-text>
      </v-card>

    </v-container>
  </v-row>
</template>

<script>
import SearchService from '@/services/SearchService'

export default {
  data () {
    return {
      //Search Categories dropdown
      lut_Indicator_categories: [
        'Bioregion', 'Conservation Species Group', 'Conservation Species Higher Group',
        'Conservation Species', 'Countries', 'Research Dimensions', 'EBV Class', 'EBV Name',
        'EOV Category', 'EOV Name', 'EV Category', 'EV Name', 'Focal Species', 'Province/State', 'Themes'
      ],
      lut_Survey_categories: [
        'Bioregion', 'Conservation Species Group', 'Conservation Species Higher Group',
        'Conservation Species', 'Conservation Areas', 'Research Dimensions', 'EBV Class', 'EBV Name',
        'EOV Category', 'EOV Name', 'EV Category', 'EV Name', 'Focal Species', 'Research Objectives',
        'Sampling Method', 'Themes'
      ],
      //Categories to display if summary tab is selected (the categories that the two surveys and indicators have in common)
      lut_Summary_categories: [
        'Bioregion', 'Conservation Species Group', 'Conservation Species Higher Group',
        'Conservation Species', 'Research Dimensions', 'EBV Class', 'EBV Name',
        'EOV Category', 'EOV Name', 'EV Category', 'EV Name', 'Focal Species', 'Themes'
      ],
      //values for a given lut
      lut_data: {},
      //name of selected category 
      category: '',
      //search value
      input: null,
      //list of search chips
      search_chips: [],
 
      //master list of search parameters
      //list of dictionaries (category, input)
      all_search_param: [],
      survey_num: null,
      survey_species: [],
      indicator_num: null,
      indicator_ebvs: [],
      table: '',
      serverItems: [],
      indicatorMetadata: {},
      surveyMetadata: {},

      //states
      //is the summary table selected
      is_summary: false,
      is_metadata: false,
      //search state 
      simpleSearch: true,
      loading: false,

      itemsPerPage: 10,
      totalItems: 0,

      indicator_enabled: true,
      survey_enabled: true,
      summary_enabled: true
    }
  },

  created() {
    this.loadLut()
  },

  methods: {
    async loadLut () {
      const response = await SearchService.fetchlut()
      this.lut_data = response.data
    },

    addChip () {
      //add chip to search chips if string is not empty
      //deal with duplicates

      this.search_chips.push(this.input)
      this.all_search_param.push({category: this.category, input: this.input})
      this.input = ''

      //check to see if the lut is compatible for both indicators and surveys
      if (!this.lut_Indicator_categories.includes(this.category)) {
        console.log('the search category is not compatible with indicators..')
        this.indicator_enabled = false
      }

      if (!this.lut_Survey_categories.includes(this.category)) {
        console.log('the search category is not compatible with surveys..')
        this.survey_enabled = false
      }

      if (!this.survey_enabled || !this.indicator_enabled) {
        this.summary_enabled = false
      }

    },

    removeChip (chip) {
      this.search_chips = this.search_chips.filter(e => e !== chip)
      this.all_search_param = this.all_search_param.filter(e => e.input !== chip)
  
      //loop through the remaining chips
      if (this.all_search_param.length == 0) {
        this.survey_enabled = true
        this.indicator_enabled = true
        this.summary_enabled = true
      }
      else {
        for (var param in this.all_search_param) {
          var category = this.all_search_param[param].category
        
          //check to see if the lut is compatible for both indicators and surveys
          if (!this.lut_Indicator_categories.includes(category)) {
            console.log('the search category is not compatible with indicators..')
            this.indicator_enabled = false
          }
          else {
            this.indicator_enabled = true
          }

          if (!this.lut_Survey_categories.includes(category)) {
            console.log('the search category is not compatible with surveys..')
            this.survey_enabled = false
          }
          else {
            this.survey_enabled = true
          }
        }
      }


      if (!this.survey_enabled || !this.indicator_enabled) {
        this.summary_enabled = false
      }
      else {
        this.summary_enabled = true
      }

    },

    switchSearch () {
      this.simpleSearch = !this.simpleSearch
      this.input = null
    },

    async submitSearch() {
      //set loading..
      this.loading = true
      this.is_metadata = false
      console.log(this.all_search_param)
      console.log(this.table)
      
      var check
      //Check if table contains all search categories
      for (var i in this.all_search_param) {
        var category = this.all_search_param[i].category
        if (this.table == 'Indicators') {
          check = this.lut_Indicator_categories.includes(category)
          if (!check) {
            console.log('lut table does not exist for the current search table..')
            this.loading = false
            this.serverItems = []
            return
          }
        } else {
          check = this.lut_Survey_categories.includes(category)
          if (!check) {
            console.log('lut table does not exist for the current search table..')
            this.loading = false
            this.serverItems = []
            return
          }
        }
      }

      var response

      if (this.simpleSearch) {
        if (this.input != null && this.input != '' && this.input != undefined) {
          response = await SearchService.search([{category: 'Any', input: this.input}], this.table)
        }
        else {
          console.log('No valid input detected..')
          this.loading = false
          return
        }
      }
      else {
        if (this.all_search_param.length > 0) {
          response = await SearchService.search(this.all_search_param, this.table)
        }        
        else {
          console.log('No valid input detected..')
          this.loading = false
          return
        }
      }

        //if summary return numbers
      if (this.table == 'Summary') {
        this.survey_num = response.data.surveys
        this.survey_species = response.data.survey_species
        this.indicator_num = response.data.indicators
        this.indicator_ebvs = response.data.indicator_ebvs
        
        
        //change the value in the ui
        this.is_summary = true
      }
      //if table return table entries
      else {
        this.serverItems = response.data

        //change the value in the ui
        this.is_summary = false
      }

      //set not loading..
      this.loading = false
    },
    
    async loadAllMetadata(event, {item}){
      this.is_metadata = true

      //using a search parameter get the survey entry from the database
      const response = await SearchService.getMetadata(item.Id, this.table)

      if (this.table == 'Indicators') {
        this.indicatorMetadata = response.data
      }
      else {
        this.surveyMetadata = response.data
      }
    }
  },
  computed:     {
    search_items: function() {
      // return SearchService.fetchlut(this.select)
      return this.lut_data[this.category]
    },
    survey_species_num: function() {
      if (this.survey_species) {
        return this.survey_species.length
      }
      return 0
    },
    survey_species_list: function() {
      var string = ''
      if (this.survey_species) {
        for (var species in this.survey_species) {
          if (species == 0) {
            string = this.survey_species[species]
          }
          else {
            string = string + '  |  ' + this.survey_species[species]
          }
        }
      }
      return string
    },
    indicator_ebv_num: function() {
      if (this.indicator_ebvs) {
        return this.indicator_ebvs.length
      }
      return 0
    },
    indicator_ebv_list: function() {
      var string = ''
      if (this.indicator_ebvs) {
        for (var ebv in this.indicator_ebvs) {
          if (ebv == 0) {
            string = this.indicator_ebvs[ebv]
          }
          else {
            string = string + '  |  ' + this.indicator_ebvs[ebv]
          }
        }
      }
      return string
    }

  }
}
</script>

<style>

  .v-table>.v-table__wrapper>table>thead>tr>th {
    font-weight: 600 !important;
    text-align: start;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  } 

</style>


  